// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pagination[data-v-1b3aab6a] { margin-top: 14px; overflow-x: auto;\n}\n.query-error[data-v-1b3aab6a] { margin-bottom: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
